"use strict";
exports.__esModule = true;
exports.HASH_TRYTE_SIZE = 81;
exports.TAG_TRYTE_SIZE = 27;
exports.SIGNATURE_MESSAGE_FRAGMENT_TRYTE_SIZE = 2187;
exports.TRANSACTION_TRYTE_SIZE = 2673;
exports.MAX_INDEX_DIFF = 1000;
exports.NULL_HASH_TRYTES = '9'.repeat(exports.HASH_TRYTE_SIZE);
exports.NULL_TAG_TRYTES = '9'.repeat(exports.TAG_TRYTE_SIZE);
exports.NULL_SIGNATURE_MESSAGE_FRAGMENT_TRYTES = '9'.repeat(exports.SIGNATURE_MESSAGE_FRAGMENT_TRYTE_SIZE);
exports.NULL_TRANSACTION_TRYTES = '9'.repeat(exports.TRANSACTION_TRYTE_SIZE);
//# sourceMappingURL=constants.js.map